import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject } from '@angular/core';
import { UtilService } from '@services/util.service';
import { RequisicaoExternaService } from '../../services/requisicaoexterna.service';

@Component({
  selector: 'app-piscinoes',
  templateUrl: './piscinoes.component.html',
  styleUrls: ['./piscinoes.component.css'],
})

export class PiscinoesComponent implements AfterViewInit {
  utilService: UtilService;
  constructor(private requisicaoExternaService: RequisicaoExternaService, @Inject(DOCUMENT) public document: Document) {
  }

  ngAfterViewInit(): void {
    this.functionAtualizarRelatorioTomus();
  }

  functionAtualizarRelatorioTomus = () => {
    this.requisicaoExternaService.ObterResultado("piscinoes").subscribe(resultado => {
      var referenciaElementoTestado = this.document.getElementById("iframeBacias") as HTMLIFrameElement;
      var parteToken = resultado.resultadoRequisicao.split(' ');
      referenciaElementoTestado.src = 'https://smsub.tiindustrial.com.br/login?page=monitoring-basin-table&token=' + parteToken[1];
    });
  }
}
